module.exports = __webpack_public_path__ + "static/media/file_text_settings.ec9aa821.ico";